export const MAILGUN_EMAIL_PROVIDER = 'MAILGUN';
export const SENDGRID_EMAIL_PROVIDER = 'SENDGRID';
